import styled from 'styled-components'
import { APP_HEADER_FIXED_HEIGHT } from '../AppHeader/styles'

export const SummaryPreview = styled.div<{
  bundleHasAnyDiscount?: boolean
  isExpanded?: boolean
}>`
  flex-grow: 1;
  margin-right: 5px;
  display: flex;
  justify-content: flex-end;

  @media (min-width: 768px) {
    margin-right: 10px;
  }

  @media (min-width: 1200px) {
    position: relative;
  }

  .expand-collapse-btn {
    background: none;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    gap: 10px;

    @media (hover: hover) {
      &:hover {
        color: ${(props) => props.theme.palette.primary.main};
      }
    }

    .price {
      font-size: 18px;
      font-weight: 500 !important; // Due to Scensum CSS
      ${(props) => !props.bundleHasAnyDiscount && 'color: #000000;'}

      @media (min-width: 1200px) {
        font-size: 23px;
      }

      &.is-high-amount {
        @media (max-width: 400px) {
          font-size: 14px;
        }
      }
    }

    i {
      font-size: 20px;
      transform: translateY(2px);

      @media (min-width: 1200px) {
        transform: translateY(3px);
        font-size: 23px;
      }
    }
  }

  .expanded-info-container {
    display: ${(props) => (props.isExpanded ? 'flex' : 'none')};
    position: absolute;
    top: ${APP_HEADER_FIXED_HEIGHT};
    left: 0;
    z-index: 3;
    width: 100vw;
    height: 100vh;
    flex-direction: column;
    gap: 30px;
    padding: 15px 15px 30px;
    overflow-y: auto;
    background-color: #ffffff;

    @media (min-width: 768px) {
      padding: 30px;
    }

    @media (min-width: 1200px) {
      top: 54px;
      left: calc(100% - 500px + 15px);
      width: 500px;
      height: 75vh;
    }
  }
`

export const CampaignAndPriceWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
`

export const Campaignbubble = styled.span`
  width: fit-content;
  padding: 2px 8px;
  border-radius: 25px;
  border: 1.5px solid ${(props) => props.theme.palette.secondary.light};
  background: ${(props) => props.theme.palette.secondary.light};
  color: ${(props) => props.theme.palette.secondary.contrastText};
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: 12px;
  font-weight: 500;
`
